import Colors from '@/constants/Colors';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import styled from 'styled-components';

export const StyledThemeActivitiesSelector = styled.div`
  height: 100%;
  overflow-y: auto;
  display: flex;
  gap: 20px;
  @media (max-width: ${MediaQueryBreakpoints.sm}) {
    flex-direction: column;
  }

  .column {
    flex: 1;
    display: flex;
    flex-direction: column;

    .activities-wrapper {
      padding: 20px;
      background: ${Colors.backgroundPaleBlue};
      border-radius: 8px;

      .activities {
        margin-top: 5px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .activity {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 5px;
          background-color: white;
          border-radius: 5px;
          border-bottom: 1px solid white;

          &:last-child {
            border-bottom: none;
          }

          &.selected {
            background-color: ${Colors.backgroundPaleBlue};
          }

          .tags {
            flex: 1;
          }
        }
      }
    }
  }
`;
